// extracted by mini-css-extract-plugin
module.exports = {"form":"OnboardingVerifyCodeForm_form__1uhOO","fieldset":"OnboardingVerifyCodeForm_fieldset__yJSex","footer":"OnboardingVerifyCodeForm_footer__2o2Ne"};